import { isUUID } from '@shared/utils';

export default function isAddedSubtaskKey(key: string) {
  return isUUID(key);
}
